import { createContext, useState } from "react";

const tabs = [
    { name: "Staging", value: 0 },
    { name: "Production", value: 1 },
  ];

export const projectTabContext = createContext();
export const projectCurrentTabContext = createContext();
export const ProjectContextProvider = (props) => {
  const [currentTab, setTab] = useState(tabs[0]);
  const contextValue = { currentTab, setTab };

  return (
    <projectTabContext.Provider value={{ tabs }}>
      <projectCurrentTabContext.Provider value={contextValue}>
        {props.children}
      </projectCurrentTabContext.Provider>
    </projectTabContext.Provider>
  );
};
